export const MASTERCARD_LOGO_ID = '9sz94m8h9agkc5dm9jp'
// Combines the original wide framing with the tighter export's high-resolution
// card region. The 7118x3764 source contains a 1092x808 card and preserves the
// original framing, so existing breakpoint geometry and roundel anchors remain valid.
export const LOYALTY_CREDIT_CARD_HERO_IMAGE_ID = 'societe-hero-sand-hd-v2'
// Purpose-made 1.9:1 crop of the hero scene. HeadData centre-crops to 1200x630,
// which on the full hero would land on empty sand rather than the card.
export const LOYALTY_CREDIT_CARD_SHARE_IMAGE_ID = 'societe-credit-card-share'
export const APPLY_URL = 'https://apply-luxuryescapessociete.moneyme.com.au/crd/qualify/employment-status'
export const EMPLOYEE_APPLY_URL = 'https://apply-luxuryescapessociete.moneyme.com.au/crd/qualify/employment-status?BID=MME-LE-CRD-LE-Internal-Discount'
export const APPLE_PAY_URL = 'https://www.apple.com/au/apple-pay/'
// Staff receive a shareable link carrying this query param. Every logged-out
// visitor who cannot be shown the page is asked to log in; the param only
// selects the employee wording on that login modal, so the circulated links
// keep reading as an employee benefit.
export const LOYALTY_CREDIT_CARD_EMPLOYEE_OFFER_PARAM = 'offer'
export const LOYALTY_CREDIT_CARD_EMPLOYEE_OFFER_VALUE = 'le-employee'
export const LOYALTY_CREDIT_CARD_LAYOUT_CONTAINER_CLASS = 'societe-credit-card-layout-container'

// Cream and rust are bespoke to the credit-card campaign and have no rebrand
// palette equivalent; every other page colour comes from theme tokens.
export const LOYALTY_CREDIT_CARD_COLOUR_CREAM = '#f3f1ea'
export const LOYALTY_CREDIT_CARD_COLOUR_RUST = '#b7410e'
export const LOYALTY_CREDIT_CARD_COLOUR_MINT = '#00f1bd'
export const LOYALTY_CREDIT_CARD_COLOUR_SLATE = '#363a45'
